<template>
  <div class="order-detail" v-if="form.SysNo">
    <div class="head">
      <h5 class="status">{{form.OrderStatusName}}</h5>
      <div class="des">服务单号：{{form.SysNo}}</div>
    </div>
    <div class="module service-info" v-if="equityType > 0">
      <div class="ico">
        <span><img :src="serviceBase[equityType].icon"/></span>
      </div>
      <div class="info">
        <div class="name">{{serviceBase[equityType].name}}</div>
        <div class="date">创建时间：{{ form.CreatedDate && form.CreatedDate.format("yyyy-MM-dd hh:mm:ss") }}</div>
      </div>
    </div>
    <div class="module store">
      <h5>预约门店</h5>
      <div class="content cd1">
        <div class="info">
          <div class="name">{{form.ServiceShopName}}</div>
          <div class="address">{{form.ServiceShopAddress}}<span class="copy" data-clipboard-action="copy" :data-clipboard-text="form.ServiceShopAddress" @click="copyWord" v-if="form.ServiceShopAddress">复制</span></div>
        </div>
        <div class="tel" @click="callTel('400-088-9898')">
          <img src="@/assets/card-order-detail-tel-ico.png" />
          <p>联系客服</p>
        </div>
      </div>
      <h5>预约时间</h5>
      <div class="content cd2">
        <span class="time">{{ form.ScheduledTime && form.ScheduledTime.format("hh:mm") }}-{{ form.ScheduledTimeEnd && form.ScheduledTimeEnd.format("hh:mm") }}</span>
        <span class="date">{{ form.ScheduledTime && form.ScheduledTime.format("yyyy年MM月dd日") }}</span>
        <span class="week">{{ weekName(form.ScheduledTime) }}</span>
      </div>
    </div>
    <div class="module express" v-if="form.InLogisticsNo || form.OutLogisticsNo">
      <h5>物流信息</h5>
      <div class="content">
        <div class="title-group">
          <div class="name ex1" v-if="form.InLogisticsNo">
            <span>寄送</span>
            <div class="info">
              <div class="express-title">{{form.InLogistics}}</div>
              <div class="express-no">单号：{{form.InLogisticsNo}}<span class="copy" data-clipboard-action="copy" :data-clipboard-text="form.InLogisticsNo" @click="copyWord">复制</span></div>
            </div>
          </div>
          <div class="name ex2" v-if="form.OutLogisticsNo">
            <span>寄回</span>
            <div class="info">
              <div class="express-title">{{form.OutLogistics}}</div>
              <div class="express-no">单号：{{form.OutLogisticsNo}}<span class="copy" data-clipboard-action="copy" :data-clipboard-text="form.OutLogisticsNo" @click="copyWord">复制</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" v-if="form.OrderStatus == 30">
      <p>仅在与客服沟通后，采取寄修方式的用户填写此项</p>
      <y-button class="btn" @click="goto(`/care/order/express/${form.SysNo}`)">{{form.InLogistics?'修改':'填写'}}寄送信息</y-button>
    </div>
  </div>
</template>


<script>
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";

export default {
  name: "ApplyRecord",
   data() {
    return {
        serviceBase: {
            "1": {
                name: "免费贴膜",
                icon: require("../../assets/ic_sticker.png"),
                type: 1
            },
            "2": {
                name: "电池更换",
                icon: require("../../assets/ic_battery.png"),
                type: 2
            },
            "3": {
                name: "屏幕更换",
                icon: require("../../assets/ic_screen.png"),
                type: 3
            },
            "4": {
                name: "整机质保",
                icon: require("../../assets/ic_insurance.png"),
                type: 4
            },
            "5": {
                name: "后壳更换",
                icon: require("../../assets/card-qy-type-5.png"),
                type: 5
            },
        },
        id: this.$route.params.id,
        equityType:this.$route.query.equityType || 1,
        form:{}
    };
  },
    computed:{
      weekName(){
          return (date) => {
              let weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
              return date?weekDay[date.getDay()]:''
          }
      }
    },
  created() {
    this.loadRecord();
  },
  methods: {
      async loadRecord() {
        this.$loading.show("正在加载...");
        try {
          const ret = await httpOpen("/WuYouCard/GetServiceOrderDetail", {
            type: "post",
            body: {
              SysNo: this.id,
            },
          });
          this.$loading.hide();
          if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
            login(this.$store, this.$router);
            return;
          } else if (!ret.Status) {
            this.$toast(ret.Message || "加载失败，请稍后重试");
          } else {
            this.form = ret.Data || {};
            if (this.form.ScheduledTime)
                this.form.ScheduledTime = new Date(this.form.ScheduledTime + "+08:00")
            if (this.form.ScheduledTimeEnd)
                this.form.ScheduledTimeEnd = new Date(this.form.ScheduledTimeEnd + "+08:00")
            if (this.form.CreatedDate)
                this.form.CreatedDate = new Date(this.form.CreatedDate + "+08:00")
          }
        } catch (e) {
            this.$loading.hide();
            console.error(e);
        }
      },
      callTel(tel){
          if (tel){
              window.location.href = 'tel://' + tel;
          } else{
              this.$toast("该门店暂无联系方式");
          }
      }
  },
};
</script>

<style lang="less" scoped>
  .order-detail{
    padding: 12px;
    min-height: 100vh;
    box-sizing: border-box;
    background: #f4f4f4 url("../../assets/card-order-detail-hd-bg.png") 0 0 no-repeat;
    background-size: 100%;
    .head{
      text-align: center;
      padding: 6.8% 0 3.6% 0;
      .status{
        font-size: 18px;
        font-weight: 600;
        color: #f3dbbf;
        margin: 0;
        padding: 0;
      }
      .des{
        margin-top: 15px;
        font-size: 13px;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .module{
      background-color: #fff;
      border-radius: 6px;
      padding: 14px 10px;
      h5{
        padding: 0 0 0 24px;
        margin: 0;
        position: relative;
        &:before{
          position: absolute;
          content: '';
          width: 18px;
          height: 18px;
          background: url("../../assets/card-order-detail-title-ico.png") 0 0 no-repeat;
          background-size: 100%;
          left: 0;
          top:50%;
          margin-top: -9px;
        }
      }
      &:not(:first-child){
        margin-top: 10px;
      }

      &.service-info{
        display: flex;
        align-items: center;
        .ico{
          margin: 0 18px 0 20px;
          >span{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            border-radius: 100%;
            background: linear-gradient(325deg,rgba(50,50,50,0.84) 8%, rgba(0,0,0,0.84) 92%);
            text-align: center;
            img{
              width: 15px;
              height: 20px;
            }
          }
        }
        .info{
          .name{
            font-size: 14px;
            font-weight: 600;
            color: #000000;
          }
          .date{
            font-size: 13px;
          }
        }
      }
      &.store{
        .content{
          margin-top: 17px;
          display: flex;
          align-items: center;
          .info{
            border-right: 2px solid #e1e1e1;
            padding-right: 22px;
            .name{
              font-size: 14px;
              font-weight: 600;
              color: #000000;
            }
            .address{
              font-size: 13px;
              font-weight: 400;
              color: #666666;
              margin-top: 4px;
              line-height: 1.5;
            }
          }
          .tel{
            padding-left: 22px;
            >img{
              width: 49px;
              height: 49px;
            }
            p{
              font-size: 12px;
              margin: 0;
              padding: 0;
            }
          }
          &.cd1{
            padding-bottom: 24px;
            margin-bottom: 24px;
            border-bottom: 1px solid #f3f3f3;
          }
          &.cd2{
            .time{
              font-size: 19px;
              font-weight: 600;
              color: #000000;
            }
            .date{
              margin-left: 10px;
              font-size: 14px;
              color: #000000;
            }
            .week{
              margin-left: 10px;
              font-size: 13px;
              color: #000000;
            }
          }
        }
      }
      &.express{
        .content{
          margin-top: 18px;
          display: flex;
          padding-bottom: 30px;
          .title-group{
            position: relative;
            .name + .name{
              margin-top: 40px;
            }
            .name{
              border-radius: 10px;
              padding: 2px 6px;
              text-align: center;
              font-size: 11px;
              position: relative;
              &:not(:first-child){
                .info{
                  border-top: 1px solid #f3f3f3;
                  padding-top: 12px;
                }
              }
              &:not(:first-child):after{
                position: absolute;
                bottom: 100%;
                left: 50%;
                content: '';
                height: 22px;
                margin-bottom: 12px;
                width: 1px;
                background-color: #979797;
              }
              &.ex1{
                border: 1px solid #b1b1b1;
                color: #585858;
                background-color: #eee;
              }
              &.ex2{
                border: 1px solid #c4b3a0;
                color: #735D44;
                background-color: #f4e0c8;
              }
              .info{
                position: absolute;
                top:0;
                left: 100%;
                width: 200px;
                z-index: 999;
                text-align: left;
                margin-left: 14px;
                .express-title{
                  font-size: 14px;
                  color: #000000;
                  font-weight: 600;
                  margin-bottom: 3px;
                }
                .express-no{
                  font-size: 13px;
                  color: #666666;
                }
              }
            }
          }
        }
      }
    }
    .copy{
      background: #f0f0f0;
      border: 1px solid #e4e4e4;
      border-radius: 10px;
      margin-left: 5px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      display: inline-block;
      line-height: 18px;
      padding: 0 6px;
    }
    .foot{
      position: fixed;
      display: flex;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #fff;
      align-items: center;
      z-index: 10;
      box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.11);
      padding: 10px 24px;
      flex-direction: column;
      p{
        font-size: 12px;
        color: #333333;
      }
    }
  }
</style>